import React__default from 'react';
import { styled } from 'styled-components';
import { isInDesktop, inNextServer } from '@fabric-app/compat';
import { platform } from '@todesktop/client-core';
import { getCompatPlatform } from '@fabric-app/compat/capabilities/platform';

const openBrowserExternal = (url, target) => {
  if (!inNextServer()) {
    const anchorEl = document.createElement("a");
    anchorEl.style.display = "none";
    anchorEl.setAttribute("href", url);
    target && anchorEl.setAttribute("target", target);
    document.body.appendChild(anchorEl);
    anchorEl.click();
    document.body.removeChild(anchorEl);
  }
};
const openExternal = (url, target) => {
  if (getCompatPlatform().openExternal(url, target)) return;
  openBrowserExternal(url, target);
};
const LinkExternal = styled.a.attrs((props) => {
  const { href, onClick } = props;
  const clickHandler = React__default.useMemo(() => {
    if (!href) {
      return onClick;
    }
    let url;
    try {
      url = new URL(href);
      if (!url) {
        throw new Error("Invalid URL");
      }
      if (![
        "http:",
        "https:",
        "mailto:",
        "fabric:"
      ].includes(url.protocol)) {
        throw new Error("Invalid protocol");
      }
    } catch {
      return (e) => {
        e.stopPropagation();
        e.preventDefault();
        onClick?.(e);
      };
    }
    const hrefSanitized = url.toString();
    return isInDesktop() ? (e) => {
      platform.os.openURL(hrefSanitized);
      e.stopPropagation();
      e.preventDefault();
      onClick?.(e);
    } : (e) => {
      e.stopPropagation();
      onClick?.(e);
    };
  }, [
    href,
    onClick
  ]);
  return {
    ...props,
    onClick: clickHandler,
    target: "_blank",
    rel: "noopener noreferrer"
  };
}).withConfig({
  displayName: "LinkExternal",
  componentId: "sc-fcc51f6b-0"
})([
  ``
]);

export { LinkExternal, openExternal };
//# sourceMappingURL=LinkExternal.js.map
